import React from 'react';
import { TrophyIcon } from '@heroicons/react/24/outline';
import { PlayerPlayMilestonePayload } from '../../../generated-api';
import { CompactEventRow } from './CompactEventRow';

interface PlayerPlayMilestoneCardProps {
  payload: PlayerPlayMilestonePayload;
  createdAt: string;
}

export const PlayerPlayMilestoneCard: React.FC<PlayerPlayMilestoneCardProps> = ({ payload, createdAt }) => (
  <CompactEventRow
    track="feed_player_milestone_card"
    to={`/players/${payload.playerId}`}
    icon={<TrophyIcon className="h-4 w-4" />}
    iconClassName="bg-amber-100 text-amber-600"
    label="Play Milestone"
    createdAt={createdAt}
  >
    <span className="font-medium text-heading">{payload.playerName}</span>
    {' reached '}
    <span className="font-semibold text-amber-700">{payload.milestone} plays</span>
  </CompactEventRow>
);
